/* Buscador predictivo del header.
 *
 * Usa la Ajax Predictive Search API de Shopify:
 *   /{locale}/search/suggest.json?q=…&resources[type]=product
 *
 * Va contra el JSON y no contra `section_id`, que devuelve HTML: con 244
 * productos y una tarjeta de tres líneas, armar el markup acá sale más barato
 * que pedirle a Shopify que renderice una sección entera en cada tecla.
 *
 * Busca por título, categoría, marca y SKU: en un catálogo mayorista la gente
 * escribe tanto «galletitas» como «La Trigueña» o el código.
 *
 * Sin JS el formulario sigue siendo un form normal que va a /search.
 */
(function () {
  var form = document.querySelector('.fp-buscador');
  if (!form || !window.fetch) return;

  var input = form.querySelector('input[type="search"]');
  var panel = form.querySelector('[data-fp-sugerencias]');
  if (!input || !panel) return;

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CAMPOS = 'title,product_type,vendor,variants.sku';
  var LIMITE = 6;
  var MINIMO = 2;

  var temporizador = null;
  var enCurso = null;
  var abierto = false;
  var indice = -1;
  var items = [];

  function escapar(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Resalta lo que escribiste dentro del título, sin romper el HTML. */
  function resaltar(texto, consulta) {
    var limpio = escapar(texto);
    var termino = consulta.trim();
    if (!termino) return limpio;
    var i = limpio.toLowerCase().indexOf(escapar(termino).toLowerCase());
    if (i === -1) return limpio;
    var largo = escapar(termino).length;
    return limpio.slice(0, i) + '<mark>' + limpio.slice(i, i + largo) + '</mark>' + limpio.slice(i + largo);
  }

  function miniatura(url) {
    if (!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=96';
  }

  function cerrar() {
    abierto = false;
    indice = -1;
    items = [];
    panel.hidden = true;
    panel.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
  }

  function marcar(nuevo) {
    if (!items.length) return;
    if (indice >= 0 && items[indice]) items[indice].setAttribute('aria-selected', 'false');
    indice = (nuevo + items.length) % items.length;
    var el = items[indice];
    el.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', el.id);
    el.scrollIntoView({ block: 'nearest' });
  }

  function pintar(productos, consulta) {
    if (!productos.length) {
      panel.innerHTML =
        '<p class="fp-sugerencias__vacio">No encontramos nada para «' + escapar(consulta) + '».</p>';
      panel.hidden = false;
      abierto = true;
      input.setAttribute('aria-expanded', 'true');
      items = [];
      indice = -1;
      return;
    }

    var html = '<ul class="fp-sugerencias__lista" role="listbox" aria-label="Sugerencias">';
    productos.forEach(function (p, i) {
      var bajada = p.product_type || p.vendor || '';
      html +=
        '<li class="fp-sugerencia" id="fp-sug-' + i + '" role="option" aria-selected="false">' +
          '<a href="' + escapar(p.url) + '" tabindex="-1">' +
            (p.featured_image && p.featured_image.url
              ? '<img class="fp-sugerencia__foto" src="' + escapar(miniatura(p.featured_image.url)) + '" alt="" loading="lazy" width="48" height="48">'
              : '<span class="fp-sugerencia__foto fp-sugerencia__foto--vacia" aria-hidden="true"></span>') +
            '<span class="fp-sugerencia__texto">' +
              '<span class="fp-sugerencia__titulo">' + resaltar(p.title, consulta) + '</span>' +
              (bajada ? '<span class="fp-sugerencia__meta">' + escapar(bajada) + '</span>' : '') +
            '</span>' +
          '</a>' +
        '</li>';
    });
    html += '</ul>';
    html +=
      '<a class="fp-sugerencias__todos" href="' + escapar(raiz) + 'search?q=' +
      encodeURIComponent(consulta) + '&type=product">Ver todos los resultados</a>';

    panel.innerHTML = html;
    panel.hidden = false;
    abierto = true;
    input.setAttribute('aria-expanded', 'true');
    items = [].slice.call(panel.querySelectorAll('[role="option"]'));
    indice = -1;
  }

  function buscar(consulta) {
    if (enCurso) enCurso.abort();
    var control = typeof AbortController !== 'undefined' ? new AbortController() : null;
    enCurso = control;

    var url = raiz + 'search/suggest.json'
      + '?q=' + encodeURIComponent(consulta)
      + '&resources[type]=product'
      + '&resources[limit]=' + LIMITE
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=' + CAMPOS;

    fetch(url, control ? { signal: control.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (d) {
        var productos = (d.resources && d.resources.results && d.resources.results.products) || [];
        pintar(productos, consulta);
      })
      .catch(function (e) {
        /* Un abort no es un error: es que seguiste escribiendo. */
        if (e && e.name === 'AbortError') return;
        cerrar();
      });
  }

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-expanded', 'false');
  input.setAttribute('aria-controls', panel.id);

  input.addEventListener('input', function () {
    var consulta = input.value.trim();
    clearTimeout(temporizador);
    if (consulta.length < MINIMO) { cerrar(); return; }
    /* 220ms: alcanza para no disparar una petición por tecla y no se siente
       lento al escribir. */
    temporizador = setTimeout(function () { buscar(consulta); }, 220);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { cerrar(); return; }
    if (!abierto || !items.length) return;

    if (e.key === 'ArrowDown') { e.preventDefault(); marcar(indice + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); marcar(indice - 1); }
    else if (e.key === 'Enter' && indice >= 0) {
      e.preventDefault();
      var a = items[indice].querySelector('a');
      if (a) window.location.href = a.getAttribute('href');
    }
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= MINIMO && !abierto) buscar(input.value.trim());
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) cerrar();
  });

  form.addEventListener('submit', cerrar);
})();
